<template>
<div class="bump">
      
    <v-data-table
      :headers="fcf"
      :items="fcfData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
      <h2 style="text-align: left;color: #555;">DCF Assumptions</h2>
      <p style="text-align: left;margin-bottom: 2px">Discount Rate: 80%</p>
      <p style="text-align: left;">Multiple: 5</p>
      <v-data-table
      :headers="dcf"
      :items="dcfData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
      <v-data-table
      :headers="equity"
      :items="equityData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
      <v-data-table
      :headers="roi"
      :items="roiData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
      <h2 style="text-align: left;color: #555;">Terminal Multiple</h2>
      <v-data-table
      :headers="terminal"
      :items="terminalData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
</div>
</template>

<script>
export default {
  data() {
    return {
      fcf: [
        {
          text: 'FCF Calculation',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      dcf: [
        {
          text: 'DCF',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      equity: [
        {
          text: 'Equity Value',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' },
      ],
      roi: [
        {
          text: 'ROI',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'one', sortable: false, align: 'right' },
      ],
      terminal: [
        {
          text: '47,337,340',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '1', value: 'one', sortable: false, align: 'right' },
        { text: '3', value: 'two', sortable: false, align: 'right' },
        { text: '5', value: 'three', sortable: false, align: 'right' },
        { text: '7', value: 'four', sortable: false, align: 'right' },
        { text: '9', value: 'five', sortable: false, align: 'right' }
      ],
      fcfData: [
        {
          value: false,
          name: 'Revenue',
          one: '154,171',
          two: '7,780,737',
          three: '29,955,055',
          four: '57,312,388',
          five: '97,421,354'
        },
        {
          value: false,
          name: 'COGS',
          one: '1,542',
          two: '77,807',
          three: '299,551',
          four: '573,124',
          five: '974,214'
        },
        {
          value: false,
          name: 'Operating Margin',
          one: '99%',
          two: '99%',
          three: '99%',
          four: '99%',
          five: '99%'
        },
        {
          value: false,
          name: 'Gross Profit',
          one: '152,629',
          two: '7,702,930',
          three: '29,655,504',
          four: '56,739,265',
          five: '96,447,141'
        },
        {
          value: false,
          name: 'Total Market Development',
          one: '1,367,160',
          two: '1,165,176',
          three: '1,206,994',
          four: '1,252,993',
          five: '1,303,592'
        },
        {
          value: false,
          name: 'R & D - Technical Design and Development',
          one: '966,000',
          two: '1,002,000',
          three: '1,002,000',
          four: '922,000',
          five: '922,000'
        },
        {
          value: false,
          name: 'Regulatory, Compliance & Legal',
          one: '126,500',
          two: '140,000',
          three: '120,000',
          four: '80,000',
          five: '60,000'
        },
        {
          value: false,
          name: 'Management & Admin',
          one: '72,000',
          two: '84,000',
          three: '126,000',
          four: '222,000',
          five: '258,000'
        },
        {
          value: false,
          name: 'Reserve (Services & Supplies)',
          one: '60,000',
          two: '60,000',
          three: '70,000',
          four: '70,000',
          five: '70,000'
        },
        {
          value: false,
          name: 'Operating Costs',
          one: '2,591,660',
          two: '2,451,176',
          three: '2,524,994',
          four: '2,546,993',
          five: '2,613,592'
        },
        {
          value: false,
          name: 'EBITDA',
          one: '-2,439,031',
          two: '5,251,754',
          three: '27,130,510',
          four: '54,192,272',
          five: '93,833,549'
        },
        {
          value: false,
          name: 'Taxes',
          one: '0',
          two: '1,470,491',
          three: '7,596,543',
          four: '15,173,836',
          five: '26,273,394'
        },
        {
          value: false,
          name: 'Plus: Depreciation',
          one: '',
          two: '',
          three: '',
          four: '',
          five: ''
        },
        {
          value: false,
          name: 'Less: Change NWC',
          one: '',
          two: '',
          three: '',
          four: '',
          five: ''
        },
        {
          value: false,
          name: 'Less: CAPEX',
          one: '',
          two: '',
          three: '',
          four: '',
          five: ''
        },
        {
          value: false,
          name: '',
          one: '-2,439,031',
          two: '3,781,263',
          three: '19,533,967',
          four: '39,018,436',
          five: '67,560,155'
        }
      ],
      dcfData: [
        {
          value: false,
          name: 'Period',
          one: '0.5',
          two: '1.5',
          three: '2.5',
          four: '3.5',
          five: '4.5'
        },
        {
          value: false,
          name: 'FCF',
          one: '-2,439,031',
          two: '3,781,263',
          three: '19,533,967',
          four: '39,018,436',
          five: '67,560,155'
        },
        {
          value: false,
          name: 'Discount Factor',
          one: '75%',
          two: '41%',
          three: '23%',
          four: '13%',
          five: '7%'
        },
        {
          value: false,
          name: 'Discounted CF',
          one: '-1,817,946',
          two: '1,565,770',
          three: '4,493,753',
          four: '4,986,733',
          five: '4,796,941'
        },
        {
          value: false,
          name: 'Terminal Value',
          one: '',
          two: '',
          three: '',
          four: '',
          five: '33,312,089'
        },
        {
          value: false,
          name: 'EV',
          one: '47,337,340',
          two: '',
          three: '',
          four: '',
          five: ''
        }
      ],
      equityData: [
        {
          value: false,
          name: 'Enterprise Value',
          one: '47,337,340'
        },
        {
          value: false,
          name: 'Less: Net Debt',
          one: ''
        },
        {
          value: false,
          name: 'Equity Value',
          one: '47,337,340'
        }
      ],
      roiData: [
        {
          value: false,
          name: 'Equity Value',
          one: '47,337,340'
        },
        {
          value: false,
          name: 'Equity %',
          one: '32%'
        },
        {
          value: false,
          name: 'Shareholder\'s Equity',
          one: '14,911,262'
        },
        {
          value: false,
          name: 'Initial Investment',
          one: '1,425,000'
        },
        {
          value: false,
          name: 'ROI',
          one: '10 x'
        }
      ],
      terminalData: [
        {
          value: false,
          name: '25%',
          one: '135,188,041',
          two: '243,621,656',
          three: '352,055,270',
          four: '460,488,885',
          five: '568,922,499'
        },
        {
          value: false,
          name: '50%',
          one: '64,889,280',
          two: '112,625,533',
          three: '160,361,786',
          four: '208,098,039',
          five: '255,834,292'
        },
        {
          value: false,
          name: '70%',
          one: '39,514,201',
          two: '66,693,538',
          three: '93,872,874',
          four: '121,052,210',
          five: '148,231,546'
        },
        {
          value: false,
          name: '80%',
          one: '31,559,755',
          two: '52,574,916',
          three: '73,590,077',
          four: '94,605,237',
          five: '115,620,398'
        },
        {
          value: false,
          name: '90%',
          one: '25,533,639',
          two: '42,010,246',
          three: '58,486,853',
          four: '74,963,460',
          five: '91,440,068'
        }
      ]
    }
  }
}    
</script>

<style>
  
</style>